import { useState } from "react";
import { deleteProject } from "../../api/projectApi";

export default function useDeleteProject() {
  const [loading, setLoading] = useState(false);

  const removeProject = async (id) => {
    try {
      setLoading(true);

      await deleteProject(id);

      return {
        success: true,
      };
    } catch (error) {
      console.error(error);

      return {
        success: false,
        error,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    removeProject,
    loading,
  };
}